// Pure helpers (no imports) — shared by <SEO> and scripts/prerender-seo.js
// SEO: titles 50–60 chars "[Primary] - [Secondary] | Brand", descriptions 120–155 chars with a CTA.
const BRAND_SUFFIX = ' | Land Drafters';
const LLC_SUFFIX = ' | Land Drafters, LLC';
const TITLE_MIN = 50;
const TITLE_MAX = 60;
const DESC_MIN = 120;
const DESC_MAX = 155;
const TAGLINES = ['Outsourced Survey CAD Drafting', 'Survey CAD Drafting', 'CAD Drafting Services', 'CAD Drafting', 'CAD Experts', 'Outsourced', 'Experts'];
const CTAS = [' Get a free quote within 2 hours.', ' 24–48 hr turnaround, NDA on every project.', ' White-label output in your template.'];
const SHORTEN = [[' Design and Drafting', ' Drafting'], [' and Drafting', ''], [' Drafting Services', ' Drafting'], [' Services', ''], ['Professional ', ''], [' and ', ' & '], ['Engineering', 'Eng.'], ['Architectural', 'Architecture']];
const DANGLING = /[\s,&—–\-|:]+(and|for|in|of|the|to|with|&)?$/i;

const trimAtWord = (s, max) => {
  if (s.length <= max) return s;
  const cut = s.slice(0, max + 1);
  return cut.slice(0, cut.lastIndexOf(' ')).replace(DANGLING, '').trim();
};

export const fitTitle = (raw) => {
  let core = String(raw || '').replace(/\s*\|\s*Land Drafters(,? LLC)?\s*$/i, '').replace(/\s+/g, ' ').trim();
  const room = TITLE_MAX - BRAND_SUFFIX.length;
  while (core.length > room && /\s(\||—|-)\s/.test(core)) core = core.replace(/\s(\||—|-)\s(?!.*\s(\||—|-)\s).*$/, '').trim();
  for (const [a, b] of SHORTEN) if (core.length > room) core = core.replace(a, b);
  core = trimAtWord(core, room);
  const suffix = core.length + LLC_SUFFIX.length <= TITLE_MAX ? LLC_SUFFIX : BRAND_SUFFIX;
  if (core.length + suffix.length < TITLE_MIN) {
    const fits = (t) => core.length + 3 + t.length + suffix.length <= TITLE_MAX && !core.toLowerCase().includes(t.toLowerCase());
    const tag = TAGLINES.find((t) => fits(t) && core.length + 3 + t.length + suffix.length >= TITLE_MIN) || TAGLINES.find(fits);
    if (tag) core = `${core} - ${tag}`;
  }
  return `${core}${suffix}`;
};

export const fitDescription = (raw) => {
  let d = String(raw || '').replace(/\s+/g, ' ').trim();
  if (d.length > DESC_MAX) {
    const sentences = d.slice(0, DESC_MAX).match(/^.*[.!?](?=\s|$)/);
    d = sentences && sentences[0].length >= DESC_MIN ? sentences[0] : `${trimAtWord(d, DESC_MAX - 1).replace(/[.,;:]$/, '')}.`;
  }
  for (const cta of CTAS) {
    if (d.length >= DESC_MIN) break;
    if (d.length + cta.length <= DESC_MAX) d = `${d.replace(/([^.!?])$/, '$1.')}${cta}`;
  }
  return d;
};
